import React from 'react';
import screenshot from './assets/screenshot_separate.png';

interface PageProps {
  theme?: 'light' | 'dark';
}

const Home: React.FC<PageProps> = ({ theme }) => {
  const accentColor = "#00CCEB";
  const googlePlayUrl = "https://play.google.com/store/apps/details?id=com.leanderoid.spoteq_15equalizerbands&hl=en";
  const appStoreUrl = "https://apps.apple.com/se/app/spoteq31/id6765487020?l=en-GB";
  
  return (
    <div style={{ padding: "40px 20px", maxWidth: "900px", margin: "0 auto", lineHeight: "1.6" }}>
      {/* Hero Section */}
      <section style={{ textAlign: 'center', marginBottom: '40px' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '20px' }}>Master Your Sound with <span style={{ color: accentColor }}>SpotEQ31</span></h1>
        <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto', marginBottom: '30px' }}>
          The most precise and customizable mobile Equalizer.
          From 7 to 31 bands, experience your music exactly how you want it.
        </p>

           <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto', marginBottom: '30px' }}>
                 On Android since 2020
                </p>
        
        <div style={{ marginBottom: '30px' }}>
          <a 
            href={googlePlayUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#000',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              border: `2px solid ${accentColor}`,
              transition: 'transform 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <svg viewBox="0 0 512 512" width="24" height="24" fill="currentColor">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
              </svg>
              GET IT ON Google Play
            </span>
          </a>
        </div>

        <p style={{ fontSize: '1.2rem', maxWidth: '700px', margin: '0 auto', marginBottom: '30px' }}>
         NEWS: First release of SpotEQ31 for iOS is now available!
        </p>

        <div style={{ marginBottom: '30px' }}>
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#000',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              fontSize: '1.1rem',
              border: `2px solid ${accentColor}`,
              transition: 'transform 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <svg viewBox="0 0 384 512" width="24" height="24" fill="currentColor">
                <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
              </svg>
              Download on the App Store
            </span>
          </a>
        </div>

        {/* App Screenshot */}
        <div style={{ 
          marginTop: '30px', 
          display: 'flex', 
          justifyContent: 'center',
          perspective: '1000px' 
        }}>
          <img 
            src={screenshot} 
            alt="SpotEQ31 Interface" 
            style={{ 
              width: '100%', 
              maxWidth: '260px', // Reduced from 320px to make it smaller
              borderRadius: '25px', 
              boxShadow: theme === 'dark' 
                ? '0 15px 30px rgba(0, 204, 235, 0.2)'
                : '0 15px 30px rgba(0,0,0,0.15)',
              border: theme === 'dark' ? '6px solid #252525' : '6px solid #fff'
            }} 
          />
        </div>
      </section>

      {/* Key Selling Point */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '30px',
        marginBottom: '50px'
      }}>
        <div style={{ 
          padding: '20px', 
          borderRadius: '12px', 
          background: theme === 'dark' ? '#252525' : '#f9f9f9', 
          borderLeft: `5px solid ${accentColor}`,
          boxShadow: theme === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <h3>Precision for Every Ear</h3>
          <p>
            SpotEQ31 is unique in its ability to pinpoint frequency bands for each ear separately. 
            Whether you have uneven headphones or want to compensate for hearing impairment, 
            our separate-side configuration ensures a perfectly balanced listening experience.
          </p>
        </div>
        <div style={{ 
          padding: '20px', 
          borderRadius: '12px', 
          background: theme === 'dark' ? '#252525' : '#f9f9f9', 
          borderLeft: `5px solid ${accentColor}`,
          boxShadow: theme === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.05)'
        }}>
          <h3>Built-in Media Player</h3>
          <p>
            Enjoy a seamless experience with our integrated media (audio/video) and podcast player. Create playlists, search for podcast episodes and download for offline playback.
            Change sound quality on the fly without switching apps.
          </p>
        </div>
      </div>

      {/* Feature Highlights */}
      <section style={{ marginBottom: '50px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '25px' }}>Professional Grade Features</h2>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '20px' 
        }}>
          <div>
            <h4 style={{ color: accentColor }}>31-Band Precision</h4>
            <p>Choose between 7, 11, 15, 21, or 31 bands depending on how much precision you need. (Premium version up to 41 bands.)</p>
          </div>
          <div>
            <h4 style={{ color: accentColor }}>Audio Enhancements</h4>
            <p>Fine-tune mid, clarify treble, or use the 3D stereo expansion, reverb or limiter for a richer soundstage.</p>
          </div>
          <div>
            <h4 style={{ color: accentColor }}>Loudness & Gain</h4>
            <p>Set extra loudness with pre-gain volume and Bass boost.</p>
          </div>
          <div>
              <h4 style={{ color: accentColor }}>Custom dB and Hz presets</h4>
              <p>Save your presets over a pre-defined set of frequencies (Hz) or create your own custom Hz config.</p>
            </div>
          <div>
            <h4 style={{ color: accentColor }}>Android Connectivity</h4>
            <p>Works in the background with all your favorite Android music/sound apps and can automatically update EQ presets when you connect your headsets.</p>
          </div>
          <div>
            <h4 style={{ color: accentColor }}>Trusted & Highly Rated</h4>
            <p>SpotEQ31 for Android has over one million downloads, and thousands of active users who have transformed their audio. Rated with high-grade reviews on Google Play and continuously updated.</p>
          </div>
        </div>
      </section>

      {/* Use Cases */}
      <section style={{ 
        padding: '30px', 
        borderRadius: '20px', 
        background: theme === 'dark' ? '#202020' : '#f0f4f8',
        textAlign: 'center',
        marginBottom: '50px'
      }}>
        <h2>Improve Your Experience</h2>
        <p style={{ marginBottom: '25px' }}>Whether it's hardware or hearing, we've got you covered.</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '20px' }}>
          <div style={{ flex: '1', minWidth: '250px' }}>
            <strong>Fix Bad Headphones</strong>
            <p>Compensate for broken earphones where sound is uneven. Lower pre-gain to avoid distortion.</p>
          </div>
          <div style={{ flex: '1', minWidth: '250px' }}>
            <strong>Better Hearing</strong>
            <p>Tailor frequencies to your specific audiogram to enjoy music without a hearing aid.</p>
          </div>
        </div>
      </section>

      {/* Footer / Disclaimer */}
      <footer style={{ fontSize: '0.8rem', opacity: 0.7, textAlign: 'center', borderTop: '1px solid #444', paddingTop: '20px' }}>
        <p>Android: Works on Android 9 (Pie) and up. Tested with major music apps.</p>
        <p>iOS: Works from v16.6 and up.</p>
        <p><strong>Disclaimer:</strong> Listening at high volumes may damage hearing or devices. Use at your own risk.</p>
      </footer>
    </div>
  );
};

export default Home;
